
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ItemTags from '@/components/shared/ItemTags.vue';

@Component<MenuCardHorizontal>({ components: { ItemTags } })

export default class MenuCardHorizontal extends Vue {
	@Prop({ type: Object, required: true }) private menuItem!: MenuItem;
	@Prop({ type: Boolean, required: false, default: false }) private showImage!: boolean;
	@Prop({ type: String, required: false, default: null }) private imageURL!: string;
	@Prop({ type: String, required: false, default: null }) private formattedDescription!: string;
	@Getter('hidePricing', { namespace: 'restaurant' }) private hidePricing!: boolean;

	private get cardSize(): string {
		const hasImage = this.menuItem.image && this.showImage;
		const hasTags = !!this.menuItem.tags?.length;
		const hasDescription = !!this.menuItem.description;

		if (hasImage && hasTags && hasDescription) {
			return 'tall-card';
		}

		if (hasImage || (hasTags && hasDescription)) {
			return 'medium-card';
		}

		return 'short-card';
	}
}
